module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('search-header'), _vm._v(" "), _c('section', {
    staticClass: "content relative"
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-177a554f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/rateassist/components/RateAssistRouterView.vue
// module id = 2101
// module chunks = 1